import _Vue from 'vue';
import Segment from '@/utils/segment';
import Router from 'vue-router';
import Auth from '@/packages/Auth';

type pluginOptions = {
  router: Router;
  segmentId: string;
};

const SegmentAnalyticsPlugin = {
  // The install method will be called with the Vue constructor as
  // the first argument, along with possible options
  install(Vue: typeof _Vue, options: pluginOptions) {
    if (Auth.userIsImpersonated()) {
      return;
    }
    if (options.segmentId) {
      Segment.appendScript(options.segmentId);
    }

    if (options.router !== undefined) {
      options.router.afterEach((to, from) => {
        // Check if tracking is disabled via route metadata
        if (to.meta?.disableTracking) {
          return;
        }

        if (to.name) {
          const routeName = to?.name;
          const splittedName = routeName?.split('.');
          const splittedNameLength = splittedName.length;
          const properties = {
            title: to?.meta?.title,
            url: to?.fullPath
          };
          if (splittedName.length == 1) {
            Segment.setAnalyticsPage(splittedName[0], '', properties);
          } else if (splittedName[splittedNameLength - 1] != 'investments') {
            Segment.setAnalyticsPage(
              splittedName[splittedNameLength - 1],
              splittedName[0],
              properties
            );
          }
        }
      });
    }
  }
};

export default SegmentAnalyticsPlugin;
